import { iconTypes } from 'components/icon';

// import ListCard from './list-card';
import TileCard from './tile-card';

const viewTypes = [
  {
    view: 'tile',
    btnProps: {
      iconType: iconTypes.viewTileBild,
    },
    component: TileCard
  },
  /*
  {
    view: 'list',
    btnProps: {
      iconType: iconTypes.viewListBild,
    },
    component: ListCard
  }
  */
];

export {
  viewTypes as default
};
